<template>
    <div class="c-picture-box">
        <div class="img-viewer-canvas">
            <img :src="images[curentIndex]" alt="" style="width: 100%" />
        </div>
        <div class="img-viewer-thumbs-slider">
            <div class="slider-pre" @click="preClick">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="img-viewer-thumbs-container">
                <div class="img-viewer-thumb-wrapper" :style="thumbsMainStyle">
                    <div
                        v-for="(item, index) in images"
                        :key="`slider_${index}`"
                        class="img-viewer-thumb"
                        :class="{ 'is-current-thumb': curentIndex === index }"
                    >
                        <img :src="item" alt="" />
                    </div>
                </div>
            </div>
            <div class="slider-next" @click="nextClick">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        images: {
            type: Array,
            default() {
                return [];
            },
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            curentIndex: this.index,
        };
    },
    computed: {
        thumbsMainStyle() {
            const index = this.curentIndex;
            const size = 3;
            const total = this.images.length;
            let x = 0;

            const currentPage = Math.ceil(index / size);

            if (index > 2) {
                x = (index - 1) * 100;
                // 加上margin
                x += (index - 1) * 2;
            }

            let sty = {
                transform: `translate3d(-${x}px, 0px, 0px)`,
            };
            return sty;
        },
    },
    methods: {
        preClick() {
            if (this.curentIndex > 0) {
                this.curentIndex -= 1;
            }
        },
        nextClick() {
            if (this.curentIndex < this.images.length - 1) {
                this.curentIndex += 1;
            }
        },
    },
    created() {},
    mounted() {},
    watch: {
        index(val) {
            this.curentIndex = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.c-picture-box {
    height: 100%;
    width: 100%;
    position: relative;
    .img-viewer-canvas {
        height: 100%;
        overflow: hidden;
        > img {
            display: block;
            margin: 15px auto;
        }
    }
    .img-viewer-thumbs-slider {
        position: absolute;
        bottom: 10px;
        width: 100%;
        left: 0px;
        text-align: center;
        .img-viewer-thumbs-container {
            background: rgba(0, 0, 0, 0.5);

            display: inline-block;
            margin: 0px 6px;
            width: 304px;
            height: 100px;
            overflow: hidden;
        }
        .img-viewer-thumb {
            &-wrapper {
                display: flex;
                box-sizing: border-box;
                transition-property: transform;
                transition-duration: 1s;
                transition-timing-function: ease-out;
            }
            display: inline-block;
            height: 90px;
            border: 5px solid transparent;
            cursor: pointer;
            vertical-align: top;
            & + .img-viewer-thumb {
                margin-left: 2px;
            }
            > img {
                display: inline-block;
                height: 84px;
                width: 84px;
                border: 3px solid #fff;
            }
        }
        .is-current-thumb {
            border-color: #2e7df8;
            transition: border-color 0.2s ease-in-out;
        }
        .slider-pre,
        .slider-next {
            display: inline-block;
            vertical-align: top;
            height: 100px;
            line-height: 100px;
            width: 54px;
            background: rgba(0, 0, 0, 0.5);
            cursor: pointer;
            font-size: 30px;
            font-weight: bold;
        }
    }
}
</style>
